import React from 'react';
import './LayerSelector.css';

import { Avatar, Box } from '@mui/material';

import MapLayersIcon from './../../assets/images/map-layers.png';
import LayerSelectorMenu from './LayerSelectorMenu';

const LayerSelector = ({ onStyleUpdate, toggleProperties, selectedLayer }) => {
  const [active, setActive] = React.useState(false);

  if (active) {
    return (
      <LayerSelectorMenu
        close={() => setActive(false)}
        onStyleUpdate={onStyleUpdate}
        toggleProperties={toggleProperties}
        selectedLayer={selectedLayer}
      />
    );
  }

  return (
    <Box className="layer-selector" onClick={() => setActive(true)}>
      <Avatar src={MapLayersIcon} variant="square" className="layer-selector-icon" />
      <div className="layer-selector-icon-label">Layers</div>
    </Box>
  );
};

export default LayerSelector;
